import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-rating',
  templateUrl: './rating.component.html'
})
export class RatingComponent implements OnInit {

  @Input() readonly rating : number;
  @Input() readonly maxRating = 10;

  constructor() { }

  ngOnInit(): void {
  }

  get circles(): number[] {
    return Array.from({ length: this.maxRating }, (_, i) => i);
  }
}
